module.exports = __webpack_public_path__ + "img/designer-life.svg";